<template>
  <div>
    <div class="header">
      <img class="logo" src="@/assets/praiana.jpg" />
      <div class="clock">{{clock}}</div>
      <div class="stop-name">{{panelConfig.panelHeader}}</div>
    </div>
    <DeparturesTable :panelConfig="panelConfig" :stopData="stopData"></DeparturesTable>
  </div>
</template>

<script>
import DeparturesTable from './DeparturesTable';

export default {
  components: {
    DeparturesTable
  },
  props: ['panelConfig', 'stopData', 'clock'],
};
</script>

<style lang="scss" scoped>
.header {
  padding: 1em .6em;
}
.logo {
  height: 2.1em;
  width: 9em;
  margin-top: -.5em;
}
.clock {
  float: right;
}
.stop-name {
  text-align: center;
  margin-top: .5em;
}

@media only screen and (min-width: 600px) {
  .header {
    height: 3.25em;
  }
  .clock {
    font-size: 2em;
    margin-top: -.35em;
  }
  .stop-name {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 3.25em;
    padding: 0 10em;
    margin-top: 0;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>